<div
  class="border-standard-outline-light flex w-full rounded-md border"
  cdkDropListGroup>
  <div class="flex w-full flex-col gap-2 p-4">
    @for (row of rows; track $index) {
    <div
      cdkDropList
      cdkDropListOrientation="horizontal"
      [cdkDropListData]="row"
      (cdkDropListDropped)="drop($event)"
      class="flex min-h-12 w-full flex-wrap items-center gap-2 rounded"
      [class.border-dashed]="row.length === 0"
      [class.border]="row.length === 0"
      [class.border-standard-outline-light]="row.length === 0">
      @if (row.length === 0) {
      <span
        class="text-standard-text-secondary w-full text-center text-sm italic select-none"
        >{{ cmsTextProvider.footer.emptyRow }}</span
      >
      } @for (block of row; track block.id) {
      <div
        cdkDrag
        class="bg-standard-surface flex flex-1 cursor-grab items-center gap-2 rounded border p-2 text-center active:cursor-grabbing">
        <span
          class="material-symbols-rounded text-standard-icon-primary select-none"
          >drag_handle</span
        >
        <span class="material-symbols-rounded select-none"
          >{{ block.icon }}</span
        >
        <span>{{ block.name }}</span>

        <ng-template cdkDragPreview>
          <div
            class="bg-standard-surface flex items-center gap-2 rounded border p-2">
            <span class="material-symbols-rounded">drag_handle</span>
            <span>{{ block.name }}</span>
          </div>
        </ng-template>
      </div>
      }
    </div>
    }
    <div
      class="bg-standard-disabled w-full rounded p-2 text-center text-sm font-medium">
      {{ cmsTextProvider.footer.legalArea }}
    </div>
  </div>
  <div
    cdkDropList
    [cdkDropListData]="hiddenBlockItems"
    (cdkDropListDropped)="drop($event)"
    class="bg-standard-surface border-standard-outline-light flex min-w-64 flex-col gap-2 rounded-r-md border-l p-4">
    <span>{{ cmsTextProvider.footer.hiddenBlocks }}</span>
    @if (!hiddenBlocks || hiddenBlocks.length === 0) {
    <span>{{ cmsTextProvider.footer.noHiddenBlocks }}</span>
    } @else { @for (block of hiddenBlockItems; track block.id) {
    <div
      cdkDrag
      class="bg-standard-surface flex cursor-grab items-center gap-2 rounded border p-2 text-center active:cursor-grabbing">
      <span
        class="material-symbols-rounded text-standard-icon-primary select-none"
        >drag_handle</span
      >
      <span class="material-symbols-rounded select-none">{{ block.icon }}</span>
      <span>{{ block.name }}</span>

      <ng-template cdkDragPreview>
        <div
          class="bg-standard-surface flex items-center gap-2 rounded border p-2">
          <span class="material-symbols-rounded">drag_handle</span>
          <span>{{ block.name }}</span>
        </div>
      </ng-template>
    </div>
    } }
  </div>
</div>
